import { useSyncExternalStore } from "react";

const serverSnapshot = { width: 0, height: 0 };
let windowSnapshot = serverSnapshot;

function getSnapshot() {
  const { innerWidth: width, innerHeight: height } = window;
  if (windowSnapshot.width !== width || windowSnapshot.height !== height) {
    windowSnapshot = { width, height };
  }
  return windowSnapshot;
}

function getServerSnapshot() {
  return serverSnapshot;
}

function subscribe(onChange: () => void) {
  window.addEventListener("resize", onChange);
  return () => window.removeEventListener("resize", onChange);
}

const useWindowSizes = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

export default useWindowSizes;
